export default __webpack_public_path__ + "static/media/backArrow.1b436d4d.svg";